/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import { j5RegistryV1ArtifactCommandServiceArtifactDownload } from '@interxfi/api-client/generated/client-functions/j5-registry-v1-artifact-command-service-artifact-download';
import type { J5RegistryV1ArtifactCommandServiceArtifactDownloadArtifactDownloadRequest } from '@interxfi/types';
import { type UseMutationOptions, useMutation } from '@tanstack/react-query';
import { j5RegistryV1ArtifactStateEntity } from '../entities/j5-registry-v1-artifact-state';

/**
 * @generated by NormalizedQueryPlugin (get /registry/v1/artifact/c/download/:owner/:bundle/:version/:name) */

export function buildJ5RegistryV1ArtifactCommandServiceArtifactDownloadKey() { return ['/j5.registry.v1.ArtifactCommandService/ArtifactDownload'] as const; }

export function useJ5RegistryV1ArtifactCommandServiceArtifactDownload(options?: Partial<UseMutationOptions<undefined, Error, J5RegistryV1ArtifactCommandServiceArtifactDownloadArtifactDownloadRequest, unknown>>) {
    return useMutation({
        mutationKey: buildJ5RegistryV1ArtifactCommandServiceArtifactDownloadKey(),
        mutationFn: async (request: J5RegistryV1ArtifactCommandServiceArtifactDownloadArtifactDownloadRequest) => j5RegistryV1ArtifactCommandServiceArtifactDownload('', request),
        ...options
    });
}
